import type { Priority } from '@ovo/shared'
import { PRIORITY_LABELS } from '../lib/status.ts'

/** Компактная метка для ячейки: «!» — срочно, «↑» — высокий. Обычный и низкий не шумят. */
export function PriorityMark({ priority }: { priority: Priority }) {
  if (priority === 'urgent') {
    return (
      <span className="urgent-mark" role="img" aria-label="Срочно" title="Срочно">
        !
      </span>
    )
  }
  if (priority === 'high') {
    return (
      <span className="high-mark" role="img" aria-label="Высокий приоритет" title="Высокий приоритет">
        ↑
      </span>
    )
  }
  return null
}

/** Подпись приоритета для карточки задачи. */
export function PriorityLabel({ priority }: { priority: Priority }) {
  const glyph = priority === 'urgent' ? '!' : priority === 'high' ? '↑' : priority === 'low' ? '↓' : '·'
  return (
    <span className={`priority priority--${priority}`}>
      <span aria-hidden="true">{glyph}</span>
      {PRIORITY_LABELS[priority]}
    </span>
  )
}
